// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: cNeMUeiwPB
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicTextarea.module.css"; // plasmic-import: cNeMUeiwPB/css

export type PlasmicTextarea__VariantMembers = {
  disabled: "disabled";
};

export type PlasmicTextarea__VariantsArgs = {
  disabled?: SingleBooleanChoiceArg<"disabled">;
};

type VariantPropType = keyof PlasmicTextarea__VariantsArgs;
export const PlasmicTextarea__VariantProps = new Array<VariantPropType>(
  "disabled"
);

export type PlasmicTextarea__ArgsType = {};
type ArgPropType = keyof PlasmicTextarea__ArgsType;
export const PlasmicTextarea__ArgProps = new Array<ArgPropType>();

export type PlasmicTextarea__OverridesType = {
  root?: p.Flex<"textarea">;
};

export interface DefaultTextareaProps {
  disabled?: SingleBooleanChoiceArg<"disabled">;
  className?: string;
}

function PlasmicTextarea__RenderFunc(props: {
  variants: PlasmicTextarea__VariantsArgs;
  args: PlasmicTextarea__ArgsType;
  overrides: PlasmicTextarea__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <textarea
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.textarea,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root,
        { [sty.rootdisabled]: hasVariant(variants, "disabled", "disabled") }
      )}
      disabled={hasVariant(variants, "disabled", "disabled") ? true : undefined}
      placeholder={"" as const}
      value={"" as const}
    />
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "textarea";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTextarea__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTextarea__VariantsArgs;
    args?: PlasmicTextarea__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicTextarea__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicTextarea__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicTextarea__ArgProps,
          internalVariantPropNames: PlasmicTextarea__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicTextarea__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTextarea";
  } else {
    func.displayName = `PlasmicTextarea.${nodeName}`;
  }
  return func;
}

export const PlasmicTextarea = Object.assign(
  // Top-level PlasmicTextarea renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicTextarea
    internalVariantProps: PlasmicTextarea__VariantProps,
    internalArgProps: PlasmicTextarea__ArgProps
  }
);

export default PlasmicTextarea;
/* prettier-ignore-end */
